<script>
    import ProductsCollection from '../components/products/ProductsCollection.vue';

    export default {
      components: { ProductsCollection },
    };
</script>